import { render } from "./AutomationCreation.vue?vue&type=template&id=71e1e5c9&scoped=true"
import script from "./AutomationCreation.vue?vue&type=script&lang=js"
export * from "./AutomationCreation.vue?vue&type=script&lang=js"

import "./AutomationCreation.vue?vue&type=style&index=0&id=71e1e5c9&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e1e5c9"]])

export default __exports__